import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { updateFeatureFlags } from "../services/update-feature-flags";

export function useUpdateFeatureFlags() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (professionalId: string) => updateFeatureFlags(professionalId),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["professionals"] });
      
      const message = data.success
        ? `Feature flags updated successfully! Created ${data.flags_created} flags, skipped ${data.flags_skipped} existing flags.`
        : `Failed to update feature flags: ${data.error}`;
      
      toast({
        title: data.success ? "Feature Flags Updated" : "Update Failed",
        description: message,
        variant: data.success ? "default" : "destructive",
      });
    },
    onError: (error: any) => {
      console.error("Error updating feature flags:", error);
      toast({
        title: "Failed to update feature flags",
        description: error.message || "An unknown error occurred",
        variant: "destructive",
      });
    },
  });
}
